<div class="modalPlans">
    <div class="contenidoModal">
      <div class="header">
        <img src="/assets/icono/equis.svg" class="cerrar mr-2" (click)="closeModal()" alt=""/>
      </div>
     <div class="bajada">
      <h2 class="copec-bold-18" >Completa tus datos para desafiliarte</h2>
      <div class="modal-form-container">
        <div class="modal-header">
          <h6>Información Personal</h6>
        </div>
        <form [formGroup]="form ">
          <div class="form-group">
            <div class="form-row">
              <label for="nombre" class="copec-rg-16">Nombres:</label>
              <input type="text" id="nombre" name="nombre" class="copec-lg-14" formControlName="nombre">
              <div id="id-anni-10"
              class="error-messages-input"
              *ngIf="
                emptyFieldForm && !form.controls['nombre'].valid
              "
            >
              Debes ingresar los nombres
            </div>
            </div>
            <div class="form-row">
              <label for="apellidos"  class="copec-rg-16">Apellidos:</label>
              <input type="text" id="apellidos" name="apellidos" class="copec-lg-14" formControlName="apellidoPaterno">
              <div id="id-anni-10"
              class="error-messages-input"
              *ngIf="
                emptyFieldForm && !form.controls['apellidoPaterno'].valid
              "
            >
              Debes ingresar los apellidos
            </div>
            </div>
            <div class="form-row">
              <label for="rut" class="copec-rg-16">RUT:</label>
              <input type="text" id="rut" name="rut" (keypress)="onKeyPress($event)" class="copec-lg-14" formControlName="rut">
              <div id="id-anni-10"
              class="error-messages-input"
              *ngIf="
                emptyFieldForm && !form.controls['rut'].valid
              "
            >
              Debes ingresar tu rut
            </div>
            </div>
            <div class="form-row">
              <label for="telefono" class="copec-rg-16">Teléfono:</label>
              <input type="text" id="telefono" (keypress)="onKeyPress($event)" name="telefono"  class="copec-lg-14" formControlName="telefono">
              <div id="id-anni-10"
              class="error-messages-input"
              *ngIf="
                emptyFieldForm && !form.controls['telefono'].valid
              "
            >
              Debes ingresar un telefono
            </div>
            </div>
            <div class="form-row">
              <label for="email" class="copec-rg-16">Email:</label>
              <input type="email" id="email" name="email" class="copec-lg-14" formControlName="email">
              <div id="id-anni-10"
              class="error-messages-input"
              *ngIf="
                emptyFieldForm && !form.controls['email'].valid
              "
            >
              Debes ingresar un email
            </div>
            </div>
          </div>
        </form>
      </div>
      </div>
      <div class="botones">
        <button type="submit" class="cambiarme" [disabled]="isLoading" (click)="enviarFormulario()">Enviar</button>
        <button type="button" class="cancelar" (click)="closeModal()">Cancelar</button>
      </div>
</div>
